(function () {
  'use strict';

  angular
    .module('neo.home.cancellations.new')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cancellations.new', {
        url: '^/home/matches/{matchId}/cancellation/new',
        templateUrl: 'home/cancellations/new-cancellation/new-cancellation.tpl.html',
        controller: 'NewCancellationCtrl',
        controllerAs: 'vm',
        resolve: {
          cancellationTypes: function (CancellationTypesPublic) {
            return CancellationTypesPublic.query().$promise;
          },
          match: function (Matches, $stateParams) {
            return Matches.get({id: $stateParams.matchId}).$promise;
          }
        }
      });
  }
}());
